import { Box, Stack, Typography, type SxProps, type Theme } from '@mui/material';

import { redColors } from 'theme/colors';

const DOT_SX = {
  width: 7,
  height: 7,
  borderRadius: '50%',
  bgcolor: 'secondary.main',
  boxShadow: `0 0 8px ${redColors.light}`,
} as const;

interface DotLabelProps {
  label: string;
  sx?: SxProps<Theme>;
}

const DotLabel: React.FC<DotLabelProps> = ({ label, sx }: DotLabelProps) => (
  <Stack direction='row' spacing={1} sx={{ alignItems: 'center' }}>
    <Box sx={DOT_SX} />
    <Typography variant='p3' sx={{ color: 'rgba(238,240,242,0.65)', ...sx }}>
      {label}
    </Typography>
  </Stack>
);

export default DotLabel;
